import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import Worklist from '../components/worklist';
import WorklistSubMenuContainer from './submenu-container';
import PowerBiReport from '../../power-bi/components/power-bi';
import {
  updateFilters,
  updateView,
  clearWorklistData,
} from './worklist-actions';

const WorklistContainer = ({ renderMenu, match, ...props }) =>
  <>
    <WorklistSubMenuContainer renderMenu={renderMenu} />
    {match?.params?.worklistId?.includes('report') ?
      <PowerBiReport id={match?.params?.worklistId} /> :
      <Worklist {...props} />}
  </>;
WorklistContainer.propTypes = {
  match: PropTypes.object.isRequired,
  renderMenu: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  updateFilters,
  updateView,
  clearWorklistData,
};

const mapStateToProps = state => ({
  activeFilters: state.worklist.activeFilters,
  filterDefinitions: state.worklist.filterDefinitions,
  relativeTimingRangeOptions: state.worklist.relativeTimingRangeOptions,
  isDataLoading: state.worklist.isDataLoading,
  menuVisible: state.header.menuVisible,
  views: state.worklist.views,
  error: state.worklist.fetchError,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WorklistContainer));
